import {
  Action,
  ActionType,
  IStudentListClassChangeResponse,
} from "models/classchangemanagement/studentListClassChange";
import createReducer from "../../createReducer";

export interface StudentListClassChangeReducerType {
  loading: boolean;
  error?: string;
  studentListClassChangeResponse?: IStudentListClassChangeResponse;
}

const defaultState: StudentListClassChangeReducerType = {
  loading: false,
  error: undefined,
  studentListClassChangeResponse: undefined,
};

export const getStudentListClassChangeReducer =
  createReducer<StudentListClassChangeReducerType>(defaultState, {
    [ActionType.STUDENT_LIST_CLASS_CHANGE](
      state: StudentListClassChangeReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.STUDENT_LIST_CLASS_CHANGE_ERROR](
      state: StudentListClassChangeReducerType,
      action: Action<string>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.STUDENT_LIST_CLASS_CHANGE_SUCCESS](
      state: StudentListClassChangeReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        studentListClassChangeResponse: action.payload,
      };
    },

    [ActionType.STUDENT_LIST_CLASS_CHANGE_RESET](
      state: StudentListClassChangeReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        studentListClassChangeResponse: undefined,
      };
    },
  });
